module.exports = __webpack_public_path__ + "static/AppIconRecipe-2a02cc6f481487aba3c077bcb41e5d51.png";